/**
 * Returns a transform string to slug format (replace symbol with empty, replace whitespace with -, tolowercase)
 * @param {string} value
 */
export const toSlug = (value) => {
  return value
    .replace(/[^a-zA-Z0-9 ]/g, '')
    .replace(/\s/g, '-')
    .toLowerCase();
};
